import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionProgressLogsService } from '../services/constructionProgressLogs.service';
import { ConstructionProgressStatsService } from '../services/constructionProgressStats.service';
import type { ConstructionProgressLog, ProgressFilters } from '../types/construction-progress.types';
import { useState } from 'react';
import { toast } from 'sonner';

export function useConstructionProgressLogs(companyId: string, initialFilters: ProgressFilters = {}) {
  const queryClient = useQueryClient();
  const [filters, setFilters] = useState<ProgressFilters>({
    status: 'all',
    ...initialFilters
  });

  const query = useQuery({
    queryKey: ['construction-progress-logs', companyId, filters],
    queryFn: () => ConstructionProgressLogsService.getProgressLogs(companyId, filters),
    enabled: !!companyId,
  });

  const statsQuery = useQuery({
    queryKey: ['construction-progress-stats', companyId, filters.projectId],
    queryFn: () => ConstructionProgressStatsService.getProgressStats(companyId, filters.projectId),
    enabled: !!companyId,
  });

  const createMutation = useMutation({
    mutationFn: (data: Partial<ConstructionProgressLog>) => ConstructionProgressLogsService.createLog(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-progress-logs'] });
      queryClient.invalidateQueries({ queryKey: ['construction-progress-stats'] });
      toast.success('Ghi nhận tiến độ thi công thành công');
    },
  });

  return {
    logs: query.data?.data || [],
    total: query.data?.total || 0,
    stats: statsQuery.data,
    isLoading: query.isLoading || statsQuery.isLoading,
    filters,
    setFilters,
    createLog: createMutation.mutateAsync,
    isCreating: createMutation.isPending,
  };
}
